import { useEffect, useState } from 'react';
import { apiErrorHandling } from 'src/api/apierrorhandling';
import { getAssetFeatures } from 'src/api/stoApi';
import { IAssetFeature } from 'src/models';
import { generalStore } from 'src/stores/GeneralStore';

export const useAssetFeatures = () => {
  const [assetsFeatures, setAssetFeatures] = useState<IAssetFeature[] | null>(null);
  useEffect(() => {
    const load = async () => {
      generalStore.setIsLoading(true);
      try {
        const response = (await getAssetFeatures()).data;
        setAssetFeatures(response.data);
      } catch (error: any) {
        apiErrorHandling(error);
      } finally {
        generalStore.setIsLoading(false);
      }
    };
    load();
  }, []);

  return assetsFeatures;
};
